const BaseRandomizer = require('./base');
const { shuffle } = require('../math/seed-rng');
const { validateBlockSize, validateCompleteFixedBlocks } = require('../math/validation');

class BlockedRandomization extends BaseRandomizer {
  constructor() {
    super('blocked', 'Block Randomization (Fixed Block Size)');
  }

  validateParams(params) {
    params.blockSize = validateBlockSize(params.blockSize || params.arms * 2, params.arms);
    validateCompleteFixedBlocks(params.n, params.blockSize);
  }

  selectResultParameters(params) {
    return {
      ...super.selectResultParameters(params),
      blockSize: params.blockSize
    };
  }

  randomize(rng, params) {
    const sequence = [];
    let patientIndex = 0;
    let blockNumber = 1;

    while (patientIndex < params.n) {
      const blockArms = this.buildBalancedBlock(params.arms, params.blockSize);
      const randomizedBlock = shuffle(blockArms, rng);

      for (const armIndex of randomizedBlock) {
        if (patientIndex >= params.n) {
          break;
        }

        sequence.push(this.buildAssignment(patientIndex, armIndex, { blockNumber }));
        patientIndex += 1;
      }

      blockNumber += 1;
    }

    return sequence;
  }

  buildBalancedBlock(arms, blockSize) {
    const repeats = blockSize / arms;
    const block = [];

    for (let armIndex = 0; armIndex < arms; armIndex += 1) {
      for (let i = 0; i < repeats; i += 1) {
        block.push(armIndex);
      }
    }

    return block;
  }

  getExplanation() {
    return `
      <h3>Block Randomization (Fixed Block Size)</h3>
      <p>Participants are grouped into blocks. Each complete block contains the same number of assignments per arm.</p>
      <pre>For each block:
  create balanced arm list
  shuffle list using seed
  assign patients in shuffled order</pre>
      <p>This improves arm balance, especially for smaller studies.</p>
    `;
  }
}

module.exports = BlockedRandomization;
